import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UserList } from '../models/user-list'
import { UserSearch } from '../models/user-search'
import { UserListGateway } from '../gateways/user-list-gateway'
import { UserListToExcel } from '../models/user-list-excel'
@Injectable()
export class NetworkUserListGateway extends UserListGateway {
    constructor(private http: HttpClient) {
        super()
    }
    // quickSearchUserListData(): Observable<UserList[]> {

    //    return this.http.get<UserList[]>('../api/quickSearchUserListData')
    // }

    retrieveUserListData(userSearch: UserSearch): Observable<UserList[]> {
        return this.http.post<UserList[]>('../api/retrieveUserListData', JSON.stringify(userSearch))
    }
    getUserList(): Observable<UserList[]> {
        return this.http.get<UserList[]>('../api/getUserList')
    }
    getAgentList() {
        return this.http.get<UserList[]>('../api/getAllAgentsDetails/6')
    }

    retrieveExcelUserListData(userSearch: UserSearch): Observable<UserListToExcel[]> {
        return this.http.post<UserListToExcel[]>('../api/ExportUserListData', JSON.stringify(userSearch))
    }

    retrieveUserListDataSync(userSearch: UserSearch): UserList[] {
        var data = JSON.stringify(userSearch)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/retrieveUserListData', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }
    getTrainingYears(selectedYear: number): Observable<number[]> {
        return this.http.get<any>('../api/GetTrainingYears/' + selectedYear)
    }
}
